import { AxiosInstance } from 'axios'
import { useCallback, useContext } from 'react'

import { AxiosContext } from '../contexts/axios_context'

export const useAxios = (customAxios?: AxiosInstance) => {
  const axiosInstance = useContext(AxiosContext) || customAxios

  const withAxios: any = useCallback(
    (fn: any) => {
      if (fn) {
        return (...args: any) => {
          return fn(withAxios, ...args)
        }
      } else {
        return axiosInstance
      }
    },
    [axiosInstance],
  )

  return withAxios
}
